import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/works", label: "影视作品" },
  { to: "/news", label: "新闻动态" },
  { to: "/about", label: "关于" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/works?q=${encodeURIComponent(value)}`);
    setSearchOpen(false);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap text-sm font-medium transition-colors ${
      isActive
        ? "text-primary-600"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="濑户环奈官网首页">
            <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-base">
              <i className="ri-flower-fill"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 tracking-wide">
                濑户环奈
              </span>
              <span className="text-[10px] tracking-[0.2em] text-foreground-400 uppercase">
                Seto Kanna
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <form onSubmit={submitSearch} className="hidden lg:flex items-center gap-2">
              <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 w-56 focus-within:border-primary-400 transition-colors">
                <i className="ri-search-line text-foreground-400 text-base"></i>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  type="text"
                  name="keyword"
                  placeholder="搜索作品或新闻"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
                />
              </div>
            </form>

            <button
              type="button"
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="搜索"
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-200 cursor-pointer"
            >
              <i className="ri-search-line text-lg"></i>
            </button>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-200 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <form onSubmit={submitSearch} className="lg:hidden pb-3">
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-foreground-400 text-base"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                name="keyword"
                placeholder="搜索作品或新闻"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
              />
            </div>
          </form>
        )}
      </div>

      {menuOpen && (
        <nav className="md:hidden border-t border-background-200 bg-background-50">
          <div className="flex flex-col px-4 py-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `py-3 text-sm border-b border-background-100 last:border-0 ${
                    isActive ? "text-primary-600 font-medium" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}